import React, { useEffect, useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux'
import _, { parseInt } from 'lodash-es'
import { hideLoading } from 'assets/javascripts/webapp-v2/common'
import * as customerActionCreators from 'store/actions/common/customerActionCreators'
import * as bookingActionCreators from 'store/actions/common/bookingActionCreators'
import { getServiceTypesInfo } from 'store/actions/new_booking/serviceTypeActionCreators'
import vehicleTypeAPIs from 'api/vehicles'
import NewBookingContainer from 'containers/NewBookingContainer'
import { countNumberOnlineDriversActionsCreator } from 'store/toolkit/newBooking/countNumberOnlineDrivers.reducer';
import { attachmentsActionsCreator } from 'store/toolkit/newBooking/attachments.reducer';
import {
  isBookAgain,
  getParamFromURL,
  isEditBooking,
  isMarketingPage,
  isHideLoadingNewBooking,
  isHideLoadingEditBooking,
  isHideLoadingMarketingBooking as isHideLoadingMarketBooking,
  setAttachments,
} from '../utils/booking/common'
import StorageKeys from 'constants/storage-keys';
import { isCancelToEdit, isCustomerEditBooking } from 'utils/new_booking/common';
import CustomerAPI from 'api/customers';
import { VALID_PAYMENT_LIST } from 'constants/bookingConstants';
import { WAITING_PAYMENT_BEFORE_EDIT_POPUP } from 'constants/common/popupConstants';
import listenBookingPayment from './PaymentNoneBp/listenBookingPayment';
import * as customerUtil from 'utils/customerUtil';
import { DEL_ACC } from 'constants/userProfile';
import AccountManagementView from './AccountManagementView';
import paths from 'routers/paths';
import Utils from 'utils/Utils';
import CommonUtils from 'utils/common';

const SingleBookingView = () => {
  const navigate = useNavigate()
  const extraInfos = useSelector(state => state.extraInfos)
  const selectedServiceTypeID = useSelector(state => state.selectedServiceTypeID)
  const bookAgainDetails = useSelector(state => state.bookAgainDetails)
  const currentCustomer = useSelector(state => state.currentCustomer)
  const locations = useSelector(state => state.locations)
  const timeType = useSelector(state => state.timeType)
  const currentStep = useSelector(state => state.currentStep)
  const attachmentsStore = useSelector(state => state.attachments)
  const serviceTypes = useSelector(state => state.serviceTypes)
  const areaId = useSelector(state => state.extraInfos?.id)
  const selectedVehicleTypeID = useSelector(state => state.selectedVehicleTypeID)

  const [isGetSuccessDataEdit, setIsGetSuccessDataEdit] = useState(false)
  const [isGetSuccessDataMarketing, setIsGetSuccessDataMarketing] = useState(false)
  const [isWaitingCalculate, setIsWaitingCalculate] = useState(false)

  const loadedStep2 = useRef(false)

  const bookingId = window.location.pathname?.split('/')[2]
  const authenticationToken = window.localStorage.getItem(StorageKeys.ACCESS_TOKEN) || ''

  const dispatch = useDispatch()
  const dataHideLoading = {
    serviceTypes, extraInfos, selectedServiceTypeID
  }

  const isHideLoadingNew = isHideLoadingNewBooking(dataHideLoading)
  const isHideLoadingEdit = isHideLoadingEditBooking({ ...dataHideLoading, bookAgainDetails })
  const isHideLoadingMarketingBooking = isHideLoadingMarketBooking(
    { ...dataHideLoading, bookAgainDetails, isGetSuccessDataMarketing }
  )
  const finalAreaId = areaId || window.localStorage.getItem(StorageKeys.AREA_ID)

  const handleGetQuotePayment = async (id) => {
    const params = {
      id,
      section_type: 'customer_quote_payment',
    }
    const quotePayment = await CustomerAPI.getCustomerBooking(id, params)
    const quotePaymentData = quotePayment?.payment

    if (!_.isEmpty(quotePaymentData) && VALID_PAYMENT_LIST.includes(quotePaymentData.status)) {
      window.localStorage.setItem(WAITING_PAYMENT_BEFORE_EDIT_POPUP, bookingId)
      const path = `/bookings/${bookingId}`
      window.location.href = path
    }
  }

  useEffect(() => {
    const isPtl = getParamFromURL('ptl')
    const isGoToSignUp = getParamFromURL('skip') === 'fp' && getParamFromURL('sign_up') === 'true'
    if (isGoToSignUp && !currentCustomer.id) return navigate(paths.SIGN_UP)
    const shipmentId = getParamFromURL('shipmentId')
    if (isPtl || shipmentId) return (window.location.href = '/bookings/new?ftl=true')
    if (bookingId && isCustomerEditBooking()) {
      handleGetQuotePayment(bookingId)
    }
    if (isCustomerEditBooking()) {
      dispatch(listenBookingPayment(bookingId))
    }

    // handle for deletion account (link from website has param "del_acc=true")
    customerUtil.checkPramDeletionAccount(currentCustomer)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (isMarketingPage && serviceTypes.length > 0 && !isGetSuccessDataMarketing) {
      const getSuccessDataMarketing = async () => {
        const quoteId = getParamFromURL('quote_id')
        dispatch(bookingActionCreators.getInfoMarketingBooking(quoteId, () => {
            setIsGetSuccessDataMarketing(true)
          }))
      }
      getSuccessDataMarketing()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [serviceTypes?.length])

  useEffect(() => {
    if (finalAreaId  
      && !authenticationToken) dispatch(getServiceTypesInfo(finalAreaId))
    if (finalAreaId && authenticationToken
      && currentCustomer.id) dispatch(getServiceTypesInfo(finalAreaId, currentCustomer.last_login_employ_id))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [finalAreaId, currentCustomer.id, authenticationToken, currentCustomer.last_login_employ_id])

  useEffect(() => {
    if ((isHideLoadingNew || isHideLoadingEdit || isHideLoadingMarketingBooking) && finalAreaId && !currentCustomer.last_login_employ_id) {
      dispatch(bookingActionCreators.getSpecialSettingsAction(finalAreaId))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isHideLoadingNew, isHideLoadingEdit, isHideLoadingMarketingBooking, finalAreaId, currentCustomer.last_login_employ_id])

  useEffect(() => {
    if (currentCustomer.id && (isEditBooking() || isBookAgain()) && !isGetSuccessDataEdit) {
      if (isCancelToEdit()) setIsWaitingCalculate(true)
      const bookingId = window.location.pathname?.split('/')[2]
      dispatch(bookingActionCreators.getInfoEditBooking(bookingId, isBookAgain(), navigate, () => setIsGetSuccessDataEdit(true)))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentCustomer.id])

  useEffect(() => {
    if (!_.isEmpty(serviceTypes?.[selectedServiceTypeID]?.vehicle_types) && extraInfos?.default_center_lat_lng) {
      vehicleTypeAPIs.getNumberOfOnlineDrivers(selectedVehicleTypeID
        || serviceTypes[selectedServiceTypeID].vehicle_types[0], extraInfos.default_center_lat_lng, (response) => {
          dispatch(countNumberOnlineDriversActionsCreator.getOnlineDriversOnVehicleType(response))
        })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [extraInfos?.default_center_lat_lng, serviceTypes])

  useEffect(() => {
    const data = {
      locations_attributes: locations,
      time_type: timeType,
      vehicle_type_id: selectedVehicleTypeID
    }
    dispatch(customerActionCreators.calculateCustomerCashbackPercent(data))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentCustomer.current_company_id])

  useEffect(() => {
    if (currentStep === 2) loadedStep2.current = true
  }, [currentStep])

  const handleAttachments = (currentCustomer, bookingAttachments) => {
    let attachments = []
    if (localStorage.getItem(StorageKeys.SWITCH_ACCOUNT_ATTACHMENTS) === 'true') {
      const oldNumberAttachments = Utils.checkValidNumberAttachments(attachmentsStore)
      const numberAttachments = Utils.checkValidNumberAttachments(bookingAttachments)
      if (oldNumberAttachments + numberAttachments > 3) attachments = setAttachments(bookingAttachments)
      else {
        const validAttachmentStore = attachmentsStore.filter((attachment) => attachment.document_url)
        const newData = [...validAttachmentStore, ...bookingAttachments]
        attachments = setAttachments(newData)
      }
      dispatch(attachmentsActionsCreator.updateAttachments(attachments))
      localStorage.removeItem(StorageKeys.SWITCH_ACCOUNT_ATTACHMENTS)
    } else if (CommonUtils.isSingle() && !loadedStep2.current) {
      if (currentCustomer.id && bookingAttachments) attachments = setAttachments(bookingAttachments)
      else attachments = setAttachments([])
      dispatch(attachmentsActionsCreator.updateAttachments(attachments))
    }
  }

  useEffect(() => {
    if (!_.isEmpty(currentCustomer?.booking_attachments)) {
      handleAttachments(currentCustomer, currentCustomer?.booking_attachments)
    } else {
      handleAttachments(currentCustomer, [])
    }
  }, [currentCustomer?.booking_attachments])

  const hideLoadingBar = () => setTimeout(() => {
      const isDeletionAccountFeature = getParamFromURL(DEL_ACC) === 'true'
      if (isDeletionAccountFeature) return

      hideLoading()
      const id = document.getElementById('progress-loading-container-id')
      if (id) id.classList.remove('progress-loading-container-visible')
    }, 300)
  useEffect(() => {
    const element = document.getElementById('bar-percent')
    if (!isEditBooking() && !isBookAgain() && element) {
      const oldWidth = element.style.width || 0
      if (serviceTypes.length > 0 || !_.isEmpty(extraInfos.tc_link) || areaId || selectedServiceTypeID) {
        element.style.width = `${((parseInt(oldWidth) / 25) + 1) * 25}%`
        if (serviceTypes.length > 0 && !_.isEmpty(extraInfos.tc_link)
          && areaId && selectedServiceTypeID) hideLoadingBar()
      }
    } else if (element && !isCancelToEdit()) {
      const oldWidth = element.style.width || 0
      // At a time we have only flow edit/book again (isGetSuccessDataEdit) or Marketing (isGetSuccessDataMarketing)
      if (serviceTypes.length > 0 || !_.isEmpty(extraInfos.tc_link) || areaId || isGetSuccessDataEdit
        || isGetSuccessDataMarketing || !_.isEmpty(bookAgainDetails)) {
        element.style.width = `${((parseInt(oldWidth) / 20) + 1) * 20}%`
        if (serviceTypes.length > 0 && !_.isEmpty(extraInfos.tc_link) && areaId && (isGetSuccessDataEdit
        || isGetSuccessDataMarketing) && !_.isEmpty(bookAgainDetails)) hideLoadingBar()
      }
    }
  }, [serviceTypes, extraInfos.tc_link, areaId, isGetSuccessDataEdit, selectedServiceTypeID, bookAgainDetails, isGetSuccessDataMarketing])
  
  return (
    <>
      {
        (isHideLoadingNew || isHideLoadingEdit || isHideLoadingMarketingBooking)
        && (
          <>
            <NewBookingContainer
              area={extraInfos}
              termsAndConditionsLink={extraInfos?.tc_link?.non_bp || ''}
              privacyPolicyLink={extraInfos.privacy_policy_link || ''}
              isWaitingCalculate={isWaitingCalculate}
              setIsWaitingCalculate={setIsWaitingCalculate}
            />
            <AccountManagementView />
          </>)
      }
    </>
  )
}

export default SingleBookingView
